module.exports = __webpack_public_path__ + "img/logo.1c17f6a0.png";